import { Language } from "../../models/Translation";
import { LanguageActionTypes, REQUEST_LANGUAGES } from "./types";
import * as translationApi from "../../api/translationApi";
import { isOk } from "../../result";

function fetchLanguages(
  languages: ReadonlyArray<Language>
): LanguageActionTypes {
  return {
    type: REQUEST_LANGUAGES,
    payload: languages
  };
}

export const thunkFetchLanguages = () => async (dispatch: any) => {
  try {
    const result = await translationApi.listLanguages();
    if (isOk(result)) {
      dispatch(fetchLanguages(result.value));
    }
  } catch (error) {
    console.log(error);
  }
};
